/**
 * Past Highlights 媒体地址（完整 URL，不做拼接）
 * 上线 Shopify：在后台 Files 点「复制链接」，逐条替换下方地址（保留 ?v= 参数）
 */
(function (global) {
  'use strict';

  /* 瀑布流封面 1–29（按列从左到右顺序） */
  var WF_COVERS = [
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/1_ecbc8b8e-c770-45c3-ba8a-bd557f576b2e.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_6d01c74d-5813-4f4b-88fd-dcbb4fb39ee1.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/3_91ac80fe-3f42-48a5-ab04-84d0abcf0e18.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/4_2e4219b9-ac56-4f77-b6e6-5430d58b09ed.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/5_12ee24d0-eda3-49e2-9f73-9fe51a0d8bd5.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/6_0ee4fef9-72b2-429b-ad6f-34a6f504f1c8.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/7_dbb32c9d-27ff-4da4-995e-2383e5598b78.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/8.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/9_e5af6401-f6d9-404d-a140-c73ac52e1273.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/10_710bf277-acbe-40a3-8455-5f14b1f8dc5a.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/11_e083397e-755e-48eb-92da-21df9589150b.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/12_5153b509-e9b1-4c60-a925-de6518fb8591.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/13_64f02b17-b4f8-414e-ac50-bab3f818c052.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/14.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/15_7e5d40da-879a-4c56-84be-79ed554f0b10.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/16.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/17.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/18.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/19.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/20.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/21.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/22.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/23.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/24.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/25.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/26.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/27.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/28.png?v=1783408953',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/29.png?v=1783408953'
  ];

  /* 瀑布流大图 / 视频（与封面编号对应） */
  var WF_FULLS = [
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/1_4a8e5fe8-d278-4cac-a012-11045df3e332.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_0f3c4a41-5b4b-45e6-afb4-40ae5fcb3ce1.png?v=1783410873',
    'https://cdn.shopify.com/videos/c/o/v/89b14ffa071e4e119f376ea4581a422c.mp4',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/4_0723bdb5-2a0c-4781-ab97-df53e5361131.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/5_e81268b4-2757-4eb4-a938-7064f591e654.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/6_02a644ed-f476-4207-8301-335f8c87831d.png?v=1783410872',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/7_c9d99aca-d0c5-4879-a0e3-fa21d3c2e53c.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/8_f8612962-db78-429d-9595-608d4a44cd4c.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/9_0db9cced-baa7-4b0a-8a7b-c282ca19306f.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/10_b81de7ff-e0e3-4e2c-97bf-1377afd31d1e.png?v=1783410873',
    'https://cdn.shopify.com/videos/c/o/v/aca1dfd19d404c579f32dd61cb778206.mov',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/12_1fea2c31-ee45-46ab-9327-dd7d0c2e5547.png?v=1783410872',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/13_b2e553db-4ca7-4bf5-991a-f2ce869230e4.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/14_f9e81216-9d8b-4168-ae4c-a24442c31520.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/15_cc80d5ca-9060-45ab-997d-16295710bd72.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/16_5f97dacb-0a7e-406f-8cfb-4c752d5a84be.png?v=1783410874',
    'https://cdn.shopify.com/videos/c/o/v/1718c1118dc54b009bece6d582d97f5c.mov',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/18_18b4491a-97da-4038-89ec-594c5161d6e6.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/19_83501ce0-c6bd-4116-9915-120c41471ae3.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/20_6264696a-7b02-40ae-9533-9e2dbd564790.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/21_fb4bcd30-c393-4aa9-aa67-08ebe754ffc7.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/22_df279e33-6faa-463d-b392-064d1a2a4ff4.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/23_7a251282-7d0d-467e-b3f6-d8a18e39c743.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/24_d4b1bfc8-0f36-4e64-adcb-a0a737079ce1.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/25_719d71b9-25b1-41c5-8d73-2014b235ea97.png?v=1783410874',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/26_e82f58a9-d59d-4b79-8dec-e0f40b49ceb2.png?v=1783410874',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/27_effeef50-f6f6-4334-99d9-5cc5035f0997.png?v=1783410873',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/28_7ca2a325-3b1f-4ed3-967b-4ae8d3264e62.png?v=1783410874',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/29_9eadc9ca-f0e1-417e-8496-9d7ef473b455.png?v=1783410873'
  ];

  var WF_TYPES = [
    'image', 'image', 'video', 'image', 'image', 'image', 'image', 'image', 'image', 'image',
    'video', 'image', 'image', 'image', 'image', 'image', 'video', 'image', 'image', 'image',
    'image', 'image', 'image', 'image', 'image', 'image', 'image', 'image', 'image'
  ];

  /* 精选作品 · PC 轮播 */
  var FEAT_PC = [
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/1_06d94634-e807-4cd9-8c50-56eef3b51334.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_fd42e961-3ca0-4bd3-a502-83013ba9ac4b.png?v=1783411646',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/3_a108079d-b5ad-43c0-b61d-0aab0736e568.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/4_8fce4e6d-d9a5-4dfe-abf5-38db299a28ed.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/5_66747efd-d917-41bc-b186-dd1110ef0b5c.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/6_92b5cd3d-fcc6-4c04-b181-ef8a9d4386cb.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/7_e2030d09-a2b5-488e-9fa4-462a7801d800.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/8_b406a6e7-e66f-4f6b-a4be-26c4c22f5f0a.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/9_2632a5fd-27a4-4ec9-9509-f68c10ba5dbd.png?v=1783411645',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/10_c32d0482-ff88-4a67-b353-2d8d34d6dc05.png?v=1783411645'
  ];

  /* 精选作品 · 移动轮播 */
  var FEAT_MOB = [
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/1_3c7d91cd-3b01-498d-bfc0-aaa995d3f229.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_c455ae19-833d-4a8a-8bb3-7e075bdb69ff.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/3_6f6ad1dd-5c2b-470f-9da4-172d10990910.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/4_e96d2b50-84ee-466c-bdee-4030acf4c30b.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/5_cfcea5a9-17c6-4632-85f8-203aab19ec84.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/6_2d275828-ce72-4a7a-b486-fd7cd0250910.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/7_2c366b02-6ee5-420c-b974-e8a3395e2ea6.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/8_c0e616b1-c2a8-458b-ac89-b1ec2d6b9779.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/9_1d1e7bc3-3956-4e41-97d7-108652ad806f.png?v=1783411784',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/10_cc7e4f0b-84b6-4474-a322-4d2a9061f44e.png?v=1783411784'
  ];

  /* 精选作品 · Lightbox 大图 */
  var FEAT_FULL = [
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/1_e8ba00c0-abf3-4785-ae6e-c88f414c2e0a.png?v=1783412319',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/2_3b201f3e-f5b4-4511-8ee1-ed75c3596b75.png?v=1783412320',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/3_772f1e43-cbf0-418f-8a1f-4f0952507065.png?v=1783412319',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/4_05187f67-7c78-4e30-a902-cbb7ed63a803.png?v=1783412320',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/5_b8563e08-c55b-415a-9215-a2ab01b59735.png?v=1783412320',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/6_92a56828-d656-4904-8f54-446ba09f1b63.png?v=1783412319',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/7_c8a77bf9-2ba2-42af-bd54-6582e62f0e53.png?v=1783412320',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/8_bd21e33b-9da3-4a8e-8b47-08c70daa505a.png?v=1783412319',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/9_36cf79fe-b5b7-4839-b80f-8da98fb63dc0.png?v=1783412319',
    'https://cdn.shopify.com/s/files/1/0046/9742/3907/files/10_cb7fe073-a4dc-42dc-a34a-bf74ced9c2bb.png?v=1783412320'
  ];

  /* 可选：Lightbox 右下角 badge，留空则不显示 */
  var FEAT_BADGES = [
    '', '', '', '', '', '', '', '', '', ''
  ];

  var WATERFALL_ITEMS = WF_COVERS.map(function (cover, i) {
    return {
      id: i + 1,
      cover: cover,
      full: WF_FULLS[i],
      type: WF_TYPES[i] === 'video' ? 'video' : 'image'
    };
  });

  var FEATURED_ITEMS = FEAT_PC.map(function (srcPc, i) {
    return {
      id: i + 1,
      srcPc: srcPc,
      srcMob: FEAT_MOB[i],
      full: FEAT_FULL[i],
      cover: srcPc,
      badge: FEAT_BADGES[i] || ''
    };
  });

  global.UGC_HIGHLIGHTS = {
    WATERFALL_ITEMS: WATERFALL_ITEMS,
    FEATURED_ITEMS: FEATURED_ITEMS
  };
})(typeof window !== 'undefined' ? window : this);
